<template>
    <form-row title="Is a Final Plat Required?" :no_border="true" class="mt-8">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="final_plat_is_required"
                v-model="final_plat_is_required"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        final_plat_is_required: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
